import { render, staticRenderFns } from "./planModel.vue?vue&type=template&id=67c21693&scoped=true"
import script from "./planModel.vue?vue&type=script&lang=js"
export * from "./planModel.vue?vue&type=script&lang=js"
import style0 from "./planModel.vue?vue&type=style&index=0&id=67c21693&lang=scss&scoped=true"
import style1 from "./planModel.vue?vue&type=style&index=1&id=67c21693&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c21693",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67c21693')) {
      api.createRecord('67c21693', component.options)
    } else {
      api.reload('67c21693', component.options)
    }
    module.hot.accept("./planModel.vue?vue&type=template&id=67c21693&scoped=true", function () {
      api.rerender('67c21693', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/insuranceManage/mainFrom/planModel.vue"
export default component.exports